/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var HockeyPuckIcon = createIcon({
  name: 'HockeyPuckIcon',
  height: 512,
  width: 512,
  svgPath: 'M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default HockeyPuckIcon;